import { SkeletonProfileHeader } from './primitives';
import { ProfileContentSkeleton } from './ProfileContentSkeleton';

/**
 * Full-page skeleton for the profile page.
 * Matches AdminPageLayout with AdminHeader (blue variant) and UnifiedBookingList content.
 * Composes from ProfileContentSkeleton to avoid duplication.
 */
export function ProfilePageSkeleton() {
  return (
    <div
      className="mx-auto w-full min-w-0 max-w-6xl space-y-6 p-6"
      aria-busy="true"
      aria-label="Loading profile page"
    >
      {/* Profile Header - Matches AdminHeader with blue variant */}
      <SkeletonProfileHeader />

      {/* Content Section - Reuse ProfileContentSkeleton */}
      <ProfileContentSkeleton />
    </div>
  );
}
